<template>
  <div class="enterp-list">
    <div class="enterp-list-form">
      <el-form ref="form" label-width="130px" size="small" :model="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="合同编号" prop="contractNo">
              <el-input placeholder="请输入合同编号" v-model="form.contractNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同名称" prop="contractName">
              <el-input placeholder="请输入甲方名称" v-model="form.contractName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="contractStatus">
              <el-select v-model="form.contractStatus">
                <el-option v-for="(item, index) in contractStatusAll" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!--
          <el-col :span="8">
            <el-form-item label="合同签署日期" prop="time">
              <el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          -->
          <el-col :span="24">
            <el-form-item style="margin-bottom: 0px; text-align: right;">
              <el-button @click="resetForm()">重置</el-button>
              <el-button type="primary" @click="submitForm()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="enterp-list-opea">
      <el-button @click="generateContract()">生成企业合同</el-button>
      <el-button size="small" @click="downloadAll()">导出</el-button>
    </div>
    <el-table size="small" :data="data">
      <el-table-column prop="contractNo" label="合同编号" width="150"> </el-table-column>
      <el-table-column prop="contractName" label="合同名称" width="300px"> </el-table-column>
      <el-table-column prop="serviceRate" label="服务费率" width="160"> </el-table-column>
      <!-- <el-table-column prop="comfirmInvoiceTime" label="服务事项" width="160"></el-table-column> -->
      <el-table-column prop="invoiceClassName" label="发票类别名称" width="200"></el-table-column>
      <el-table-column prop="providerName" label="供应商名称" width="300"></el-table-column>
      <el-table-column label="合同期起" width="160">
        <template slot-scope="scope">
          {{ getFormatDate(scope.row.contractBegin) }}
        </template>
      </el-table-column>
      <el-table-column label="合同期止" width="160">
        <template slot-scope="scope">
          {{ getFormatDate(scope.row.contractEnd) }}
        </template>
      </el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="合同执行状态" width="160">
        <template slot-scope="scope">
          {{ getConcatStatus(scope.row.contractStatus) }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDownload(scope.row)">下载</el-button>
          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next"
      :current-page.sync="page.index"
      :page-size="page.size"
      :total="count"
      @current-change="handlePageChange()"
    >
    </el-pagination>

    <edit-enterprise ref="editRef" @confirm="handleContractConfirm"></edit-enterprise>
  </div>
</template>

<script>
import api from '@/api/api';
import { contractStatusAll } from '@/utils/enum';
import { parseTime } from '@/utils';
import editEnterprise from './components/editEnterpise';

export default {
  name: 'invoiceApply',
  components: {
    editEnterprise,
  },
  created() {
    this.getContractList();
  },
  data() {
    return {
      contractStatusAll,
      form: {
        contractNo: '',
        contractName: '',
        contractStatus: -1,
        time: '',
      },
      data: [],
      count: 0,
      page: {
        index: 1,
        size: 10,
      },
    };
  },
  methods: {
    submitForm() {
      this.page.index = 1;
      this.getContractList();
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.page.index = 1;
      this.getContractList();
    },
    handlePageChange() {
      this.getContractList();
    },
    generateContract() {
      api
        .generateContract()
        .then((res) => {
          if (res === 0) {
            this.$message({
              type: 'success',
              message: '已生成企业合同',
            });
          }
          // this.data = res.data;
          // this.count = res.count || 0;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },
    downloadAll() {
      /*
      const time = this.form.time;
      //let contractBegin = '';
      //let contractEnd = '';
      if (time && Array.isArray(time) && time.length > 1) {
        contractBegin = new Date(time[0]).getTime();
        contractEnd = new Date(time[1]).getTime();
      }
      */
      const params = {
        contractNo: this.form.contractNo,
        contractName: this.form.contractName,
        invoiceClassId: '',
        contractStatus: this.form.contractStatus,
      };

      api.downloadContract(params);
    },
    handleDownload(data) {
      if (!data.fileId) {
        this.$message({
          type: 'error',
          message: '不存在合同文件',
        });
        return;
      }
      const params = {
        fileId: data.fileId,
      };

      api.fileDownload(params);
    },
    handleEdit(data) {
      this.$refs.editRef.show(data);
    },
    getContractList() {
      /*
      const time = this.form.time;
      let contractBegin = '';
      let contractEnd = '';

      if (time && Array.isArray(time) && time.length > 1) {
        contractBegin = new Date(time[0]).getTime();
        contractEnd = new Date(time[1]).getTime();
      }
      */
      const params = {
        contractNo: this.form.contractNo,
        contractName: this.form.contractName,
        invoiceClassId: '',
        contractStatus: this.form.contractStatus,
      };
      Object.assign(params, this.page);

      params.index -= 1;

      api
        .getContractList({
          params: {
            params,
          },
        })
        .then((res) => {
          this.data = res.data;
          this.count = res.count || 0;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    handleContractConfirm(data) {
      api
        .editContractInfo({
          params: {
            data,
          },
        })
        .then(() => {
          this.$refs.editRef.close();
          this.getContractList();
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    getFormatDate(time) {
      return time ? parseTime(new Date(time), '{y}/{m}/{d}') : '';
    },
    getConcatStatus(status) {
      // eslint-disable-next-line arrow-parens
      const findStatus = contractStatusAll.find((item) => item.value === status);
      return findStatus ? findStatus.label : '';
    },
  },
};
</script>

<style lang="less" scoped>
.enterp-list {
  .enterp-list-form {
    border: 1px solid #ebeef5;
    padding: 16px;
    .form-title {
      font-size: 16px;
      font-weight: 700;
      color: #050505;
      margin-bottom: 20px;
      display: block;
    }
  }
  .enterp-list-opea {
    text-align: right;
    padding: 16px 0px;
  }
  /deep/ .el-date-editor--daterange.el-input__inner {
    width: 100%;
  }
  /deep/ .el-select {
    display: block;
  }
  /deep/ .el-pagination {
    text-align: right;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contractManage/enterpList.vue